import type {
  IncidentListDTO,
  NotificationRule,
} from '@eppendorf/vnls-notifications-utils';
import { QueryClient, type FetchInfiniteQueryOptions } from '@tanstack/react-query';

import { PaginatedResponse } from '$shared/types';
import {
  prepopulateCache,
  prepopulateInfiniteQueryCache,
} from '$shared/utils/react-query.utils';

import { createIncidentsQueryWithQueryParams } from '$features/incidents/incidents.api';
import { createNotificationRulesQueryWithQueryParams } from '$features/notifications/notification-rules.api';
import { NotificationsPage } from '$pages/notifications/notifications-page';

export async function incidentsLoader(queryClient: QueryClient): Promise<null> {
  return prepopulateInfiniteQueryCache<IncidentListDTO[]>(
    queryClient,
    createIncidentsQueryWithQueryParams() as FetchInfiniteQueryOptions<IncidentListDTO[]>,
  );
}

export async function notificationRulesLoader(queryClient: QueryClient): Promise<null> {
  return prepopulateCache<PaginatedResponse<NotificationRule>>(
    queryClient,
    createNotificationRulesQueryWithQueryParams({ page: 1, pageSize: 10 }),
  );
}

export async function notificationsLoader(queryClient: QueryClient): Promise<null> {
  await Promise.all([incidentsLoader(queryClient), notificationRulesLoader(queryClient)]);

  return null;
}

export function Notifications() {
  return <NotificationsPage />;
}
